import { useState, useRef } from "react";
import { useUserProfile } from "./useUserProfile";
import { useUpdateUserProfile } from "./useUpdateUserProfile";
import type { UserProfile } from "../requests/user/profile";

export const useUserInfo = () => {
  const {
    userProfile,
    isLoading: isLoadingProfile,
    refreshUserProfile,
  } = useUserProfile();
  const { updateUserProfile, isLoading: isUpdating } =
    useUpdateUserProfile(refreshUserProfile);

  const [isEditing, setIsEditing] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const lastUserProfileRef = useRef<UserProfile | null>(null);
  if (userProfile && userProfile !== lastUserProfileRef.current) {
    lastUserProfileRef.current = userProfile;
    setFirstName(userProfile.firstName || "");
    setLastName(userProfile.lastName || "");
  }
  if (!userProfile) lastUserProfileRef.current = null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const success = await updateUserProfile({
      firstName: firstName.trim() || undefined,
      lastName: lastName.trim() || undefined,
    });

    if (success) {
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    // Restaurar valores del perfil
    if (userProfile) {
      setFirstName(userProfile.firstName || "");
      setLastName(userProfile.lastName || "");
    } else {
      setFirstName("");
      setLastName("");
    }
    setIsEditing(false);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const isLoading = isLoadingProfile || isUpdating;

  return {
    userProfile,
    isLoading,
    isLoadingProfile,
    isEditing,
    firstName,
    lastName,
    setFirstName,
    setLastName,
    handleSubmit,
    handleCancel,
    handleEdit,
  };
};
